var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":_vm.imgObj[_vm.type],"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }